import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { Navigate, useParams } from "react-router";

import ListGeometryTypeRevisions from "./ListGeometryTypeRevisions.graphql";
import { TAXONOMY_BASE } from "../../../../constants";

/** Was a data-router `loader`; see BimClass/RedirectToRevision. */
export default function RedirectToRevision() {
    const { bimClassID, geometryTypeID } = useParams();

    const listGeometryTypeRevisions = useQuery(
        gql(ListGeometryTypeRevisions),
        {
            variables: {
                id: geometryTypeID,
            },
        },
    );

    if (listGeometryTypeRevisions.loading) return "loading";
    if (listGeometryTypeRevisions.error) return "error";

    const geometryType = listGeometryTypeRevisions.data?.geometryType;
    const latest = geometryType?.revisions?.slice().pop();

    if (!latest) return <Navigate replace to={ `${ TAXONOMY_BASE }/BimClasses/${ bimClassID }` } />;

    return (
        <Navigate
            replace
            to={ `${ TAXONOMY_BASE }/BimClasses/${ bimClassID }/GeometryTypes/${ geometryTypeID }/revisions/${ latest.id }` }
        />
    );
}
